export function phoneNumberValid(number) : boolean {
  return number && number.toString().length >= 10 && number.toString().length <= 12;
}

export function postalCodeValid(number) : boolean {
  return number && number.toString().length === 5;
}

export function emailValid(str) : boolean {
  return str && str.length >= 3 && str.indexOf('@') > -1;
}